import EventList from "./List";
import ListAltIcon from "@mui/icons-material/ListAlt";
import React from "react";
import { Box, IconButton } from "@mui/material";

export default function EventFob({ siteUid }) {
  // state for open
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      style={{
        position: "absolute",
        top: "1rem",
        left: "1rem",
        zIndex: 1000,
        backgroundColor: "rgba(255,255,255,1)",
        borderRadius: "1rem",
        width: "fit-content",
      }}
    >
      <IconButton
        style={{
          border: "1px solid rgba(0,0,0,0.4)",
          borderRadius: "1rem",
        }}
        onClick={handleOpen}
      >
        <ListAltIcon />
      </IconButton>
      <EventList open={open} onClose={handleClose} siteUid={siteUid} />
    </Box>
  );
}
